/**
 * Constants for Frontend/Homepage module
 *
 * Centralized labels and strings for consistency and easier i18n.
 */

import type { HomepageProductSlider, HomepagePromoBlock } from '../types'

/**
 * Default skeleton objects for loading states
 * Used in HomepageSections when data is loading
 */
export const DEFAULT_PROMO_BLOCK: HomepagePromoBlock = {
  id: 0,
  title: '',
  image: null,
  image_position: 'left',
  link: null,
  description: null,
  sort_order: 0,
}

export const DEFAULT_PRODUCT_SLIDER: HomepageProductSlider = {
  id: 0,
  identifier: 'skeleton',
  title: '',
  source_type: 'category',
  source_value: null,
  products_count: 3,
  display_type: 'slider',
  sort_order: 0,
}

/**
 * Romanian UI labels
 */
export const LABELS = {
  // Price
  PRICE_SUFFIX: 'cu TVA',
  MSRP_PREFIX: 'PRP:',

  // Buttons
  ADD_TO_CART: 'Adauga in cos',
  VIEW_DETAILS: 'Vezi detalii',
  ADD_TO_WISHLIST: 'Adauga la favorite',
  REMOVE_FROM_WISHLIST: 'Sterge de la favorite',

  // Navigation
  NAV_PREV_SLIDE: 'Slide anterior',
  NAV_NEXT_SLIDE: 'Slide următor',

  // Error messages
  HOMEPAGE_LOADING_ERROR: 'Eroare la încărcarea datelor homepage.',
  HOMEPAGE_ERROR_FALLBACK: 'A apărut o eroare la încărcarea paginii.',

  // Category cards
  CATEGORY_SECTION_TITLE: 'Cumpără după categorii',

  // Section-level error messages
  BANNER_SLIDER_ERROR: 'Eroare la încărcarea bannerelor.',
  PRODUCT_SLIDER_ERROR: 'Eroare la încărcarea produselor.',
  PROMO_BLOCK_ERROR: 'Eroare la încărcarea blocului promoțional.',
  CATEGORY_CARDS_ERROR: 'Eroare la încărcarea categoriilor.',
} as const
